export default __webpack_public_path__ + "static/media/download-icon.87836df4.svg";